import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Toast.css';

const Toast = ({ message, type = 'success', onClose, duration = 4000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const toastContent = (
    <div className={`toast toast-${type}`} role="alert" aria-live="polite">
      <div className="toast-content">
        <div className="toast-icon">
          {type === 'success' ? '✓' : '✕'}
        </div>
        <p className="toast-message">{message}</p>
      </div>
      <button 
        className="toast-close" 
        onClick={onClose}
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );

  // Render toast directly to document body using portal
  return createPortal(toastContent, document.body);
};

export default Toast;

